<template>
  <div class="page">
    <van-nav-bar title="月度汇总分析" left-arrow @click-left="$router.back()"/>
    <section class="month">
      <button aria-label="上个月" @click="change(-1)">
        <van-icon name="arrow-left"/>
      </button>
      <b>{{ month.replace('-', ' 年 ') }} 月</b>
      <button aria-label="下个月" @click="change(1)">
        <van-icon name="arrow"/>
      </button>
    </section>
    <van-skeleton v-if="loading" title :row="10"/>
    <template v-else>
      <section class="metrics">
        <div><span>团队均分</span><b>{{ num(data.averageScore) }}</b></div>
        <div><span>提交率</span><b>{{ num(data.submissionRate) }}%</b></div>
        <div><span>待复核</span><b>{{ data.pendingReview || 0 }}</b></div>
      </section>
      <main>
        <section class="diagnosis">
          <header>
            <van-icon name="warning-o"/>
            <h2>本月综合情况</h2></header>
          <p v-for="item in data.issues || []" :key="item">{{ item }}</p>
          <van-empty v-if="!(data.issues || []).length" description="暂无综合情况"/>
        </section>
        <section class="actions">
          <header>
            <van-icon name="bulb-o"/>
            <h2>下月关注事项</h2></header>
          <p v-for="(item,index) in data.actions || []" :key="item"><i>{{ index + 1 }}</i><span>{{ item }}</span></p>
          <van-empty v-if="!(data.actions || []).length" description="暂无关注事项"/>
        </section>
        <section class="performers">
          <header>
            <van-icon name="contact"/>
            <h2>重点关注人员</h2></header>
          <article v-for="item in data.lowPerformers || []" :key="item.employeeId"><span>{{ item.employeeName }} · {{
              item.positionName
            }}</span><b>{{ num(item.score) }} 分</b></article>
          <van-empty v-if="!(data.lowPerformers || []).length" description="暂无低分人员"/>
        </section>
      </main>
    </template>
  </div>
</template>

<script>
/**
 * 主管月度汇总分析：团队均分、问题诊断与低分人员（文案由后端生成）。
 */
import coreapi from '@/utils/coreapi';

export default {
  data() {
    const d = new Date();
    return {month: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`, data: {}, loading: false};
  },
  mounted() {
    this.load();
  },
  activated() {
    this.load();
  },
  methods: {
    num(value) {
      return Number(value || 0).toFixed(1);
    },
    async load() {
      this.loading = true;
      try {
        this.data = await coreapi.supervisorDiagnosis(this.month);
      } catch (e) {
        this.$toast.fail(e.message);
      } finally {
        this.loading = false;
      }
    },
    change(offset) {
      const parts = this.month.split('-');
      const d = new Date(+parts[0], +parts[1] - 1 + offset, 1);
      this.month = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      this.load();
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/base.less";
@import "./supervisor.less";

.page {
  min-height: 100vh;
  padding-bottom: .4rem;
  background: #f6f7fb;
  color: #333;
  letter-spacing: 0
}

.month {
  height: .94rem;
  padding: 0 .3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff
}

.month button {
  width: .68rem;
  height: .68rem;
  color: #73768a;
  font-size: .3rem
}

.month b {
  color: #34364a;
  font-size: .31rem
}

.metrics {
  padding: .28rem;
  display: grid;
  grid-template-columns:repeat(3, minmax(0, 1fr));
  gap: .14rem
}

.metrics div {
  position: relative;
  min-height: 1.32rem;
  padding: .22rem .2rem;
  overflow: hidden;
  background: #fff;
  border-radius: .2rem;
  box-shadow: 0 .06rem .24rem rgba(211, 47, 47, .09);
  box-sizing: border-box
}

.metrics div:before {
  content: "";
  position: absolute;
  left: 0;
  top: .22rem;
  width: .06rem;
  height: .44rem;
  border-radius: 0 .05rem .05rem 0;
  background: @color
}

.metrics div:nth-child(2):before {
  background: #35a56f
}

.metrics div:nth-child(3):before {
  background: #D32F2F
}

.metrics span, .metrics b {
  display: block
}

.metrics span {
  color: #8a8da3;
  font-size: .22rem
}

.metrics b {
  margin-top: .1rem;
  color: #34364a;
  font-size: .36rem
}

main {
  padding: 0 .28rem
}

main > section {
  margin-bottom: .18rem;
  padding: .3rem;
  background: #fff;
  border-radius: .22rem;
  box-shadow: 0 .06rem .24rem rgba(211, 47, 47, .08)
}

main header {
  display: flex;
  align-items: center;
  padding-bottom: .12rem
}

main header .van-icon {
  width: .58rem;
  height: .58rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: .14rem;
  color: @color;
  border-radius: .14rem;
  background: #fff5f5;
  font-size: .32rem
}

main .diagnosis header .van-icon {
  color: #d9891b;
  background: #fff4e5
}

main .performers header .van-icon {
  color: #d54c4c;
  background: #fff0f0
}

h2 {
  font-size: .34rem
}

main p {
  padding: .14rem 0;
  color: #626577;
  font-size: .28rem;
  line-height: 1.5;
  border-top: 1PX solid #f0f0f3
}

.actions p {
  display: flex;
  align-items: flex-start;
  gap: .12rem
}

.actions p i {
  width: .38rem;
  height: .38rem;
  line-height: .38rem;
  flex: 0 0 .38rem;
  text-align: center;
  color: #fff;
  border-radius: 50%;
  background: @color;
  font-size: .22rem;
  font-style: normal
}

.actions p span {
  min-width: 0;
  flex: 1
}

.performers article {
  padding: .2rem 0;
  display: flex;
  justify-content: space-between;
  border-top: 1PX solid #eee
}

.performers article span {
  color: #55586a;
  font-size: .28rem
}

.performers article b {
  color: #d44d4d;
  font-size: .28rem
}
</style>



// WEBPACK FOOTER //
// src/views/efficiency/supervisor/Diagnosis.vue